// extracted by mini-css-extract-plugin
export default {"ProjectItemSectionContainer":"ProjectItemSection-module__ProjectItemSectionContainer--d7ji9"};